<template>
    <div class="flex">
       <div style="width:70%;" class="flex m-2 flex-column gap-2">
           <label>Address Line 1</label>
           <p-text :readonly="readonly" v-model="app.address1" size="large" />
       </div>
       <div class="flex m-2 flex-column gap-2">
           <label>Address Line 2</label>
           <p-text :readonly="readonly" v-model="app.address2" size="large" />
       </div>
   </div>
   <div class="flex">
       <div  class="w-full flex m-2 flex-column gap-2">
           <label>Address Line 3</label>
           <p-text v-model="app.address3" :readonly="readonly" size="large"  />
       </div>
   </div>
   <div class="flex">
       <div class="flex w-full m-2 flex-column gap-2">
           <label>City</label>
           <p-text size="large" :readonly="readonly" v-model="app.city" class="w-full" />
       </div>
   </div>
   <div class="flex m-2 flex-column gap-3">
       <label>PIN</label>
       <p-text size="large" :readonly="readonly" v-model="app.pin" class="w-full" />
   </div>
   <div class="flex">
       <div style="width:77%;" class="flex m-2 flex-column gap-2">
           <label>District</label>
           <p-text v-model="app.district" class="w-full" />
           <small>Enter the district of this address.</small>
       </div>
       <div  
           class="flex m-2 flex-column gap-2">
           <label>State</label>
           <p-text :readonly="readonly" v-model="app.state" class="w-full" />
           <small>Enter the state this address is in.</small>
       </div>
   </div>
   <div class="flex">
       <div v-if="!business" class="flex w-full m-2 flex-column gap-2">
           <label>Years Living there</label>
           <p-number suffix=" Years" v-model="app.years_staying" />     
       </div>
       <div v-else class="flex w-full m-2 flex-column gap-2">
           <label>Date moved in</label>
           <p-calender  
               v-model="app.date_moved_in" 
               showIcon
               placeholder="dd/mm/yyyy"                  
               dateFormat="dd/mm/yy"
               showButtonBar
               view="month"
               :showOnFocus="false"
           />
       </div>
   </div>
 </template>
 
 <script lang="ts">
 import { base } from "@/misc/base";
import { Options, Vue } from "vue-class-component";
 
 @Options({
   props: {
     app: Object,
     business : Boolean,
     readonly : Boolean,
   },
 })
 export default class AddressEditor extends base {
   app!: any;
   pins = [];
   pin_string : any= [];
   business! : boolean;
   readonly! : boolean;

   public selectAccount(e : string){
       const pin : any = this.pins
       .filter((el : any) => {
           return `${el.Pincode}` == e
       })[0]

      this.app.pin = e
      this.app.district = pin.District
      this.app.state = pin.State
   }

   refresh(){

       const service = this.store.state.simforce
       setTimeout(() => {
           const pin = this.app.pin ? this.app.pin : ""
           service
           .get("/pin_codes?code=" + pin)
           .then((response : any) => {

               this.pins = response.data;
           })
           .catch((error : any) => {
               console.error(error);
           });
       }, 400)
   }

   mounted(){
       this.refresh()

       if(this.app.date_moved_in)
           this.app.date_moved_in = new Date(this.app.date_moved_in)
   }

   beforeUpdate(){
       this.pin_string = this.pins
       .map((el : any) => {
           return `${el.Pincode}`
       })
       
       this.pin_string = this.pin_string
       .filter((item : any, index: number) => this.pin_string.indexOf(item) === index)
   }
 }
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
 </style>
 